import React from 'react'

import { Route, Routes, useLocation } from 'react-router-dom'

import { wrapSuspenseComponent, wrapSuspenseScreen } from '@components'
import { lazy as loadable } from '@loadable/component'

const EventAttendConfirmationModal = wrapSuspenseComponent(
  loadable(
    () =>
      import(
        '@modals/EventAttendConfirmationModal/EventAttendConfirmationModal'
      )
  )
)
const EventEditNavigator = wrapSuspenseScreen(
  loadable(() => import('./EventEditNavigator'))
)

const EventScreenNew = wrapSuspenseScreen(
  loadable(() => import('@screens/EventScreenNew/EventScreenNew'))
)

export const EventNavigator = () => {
  const location = useLocation()

  const locationState = location.state as { backgroundLocation?: Location }

  return (
    <Routes location={locationState?.backgroundLocation || location}>
      <Route index element={<EventScreenNew />} />

      <Route path='attend' element={<EventAttendConfirmationModal />} />
      <Route path='settings/*' element={<EventEditNavigator />} />
    </Routes>
  )
}

export default EventNavigator
